var _path, _rect, _rect2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLschen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20L20.5834 80.6033C20.899 84.7757 24.3764 88 28.5607 88H67.4393C71.6236 88 75.101 84.7757 75.4166 80.6033L80 20H16ZM24.6279 28L28.5607 80H67.4393L71.3721 28H24.6279Z",
    fill: "#CB3844"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 36,
    width: 8,
    height: 36,
    rx: 2,
    fill: "#CB3844"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 36,
    width: 8,
    height: 36,
    rx: 2,
    fill: "#CB3844"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22C12 20.8954 12.8954 20 14 20H82C83.1046 20 84 20.8954 84 22V26C84 27.1046 83.1046 28 82 28H14C12.8954 28 12 27.1046 12 26V22Z",
    fill: "#CB3844"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9C32 8.44772 32.4477 8 33 8H63C63.5523 8 64 8.44772 64 9V15C64 15.5523 63.5523 16 63 16H33C32.4477 16 32 15.5523 32 15V9Z",
    fill: "#CB3844"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLschen);
export default __webpack_public_path__ + "static/media/IconLöschen.dd9d2e22cb6b4a34c99cc714a1a382af.svg";
export { ForwardRef as ReactComponent };